export default __webpack_public_path__ + "859722e342914faca4fa8b1f2e4c9061.png";